<ngx-charts-bar-vertical [view]="style.view" [scheme]="colorScheme" [results]="data" [gradient]="style.gradient"
    [xAxis]="style.xAxis" [yAxis]="style.yAxis" [legend]="style.legend" [showXAxisLabel]="style.showXAxisLabel"
    [showYAxisLabel]="style.showYAxisLabel" [xAxisLabel]="style.xAxisLabel" [yAxisLabel]="style.yAxisLabel"
    [legendTitle]="style.legendTitle" [animations]="style.animations" [barPadding]="style.barPadding"
    [showGridLines]="style.showGridLines" [showDataLabel]="style.showDataLabel" [tooltipDisabled]="false">
    <ng-template #tooltipTemplate let-model="model">
        <div class="padding-6px">
            <span class="font-size-13px">{{ model?.name }}</span>
            <br>
            <span class="font-size-16px">{{ model?.value }}</span>
        </div>
    </ng-template>
</ngx-charts-bar-vertical>